import { render, staticRenderFns } from "./handleCom.vue?vue&type=template&id=d9568c46&scoped=true&"
import script from "./handleCom.vue?vue&type=script&lang=js&"
export * from "./handleCom.vue?vue&type=script&lang=js&"
import style0 from "./handleCom.vue?vue&type=style&index=0&id=d9568c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9568c46",
  null
  
)

export default component.exports